export enum CertificatesForInsuranceCompanyField {
  BOOKING_REFERENCE = 'bookingReference',
  CONFIRM_SELF_CANCELLED_BOOKING = 'confirmSelfCancelledBooking',
  EMAIL = 'email',
  FIRST_NAME = 'firstName',
  FLIGHT_DATE = 'flightDate',
  FLIGHT_NUMBER = 'flightNumber',
  FLIGHTS = 'flights',
  LAST_NAME = 'lastName',
  PHONE = 'phone',
  REASON_FOR_CERTIFICATE = 'reasonForCertificate',
  TICKET_NUMBER = 'ticketNumber',
  WORLD_TRACER_NUMBER = 'worldTracerNumber',
}

export type CertificatesForInsuranceCompanyConditionalFieldControls = Partial<{
  [CertificatesForInsuranceCompanyField.CONFIRM_SELF_CANCELLED_BOOKING]: string;
  [CertificatesForInsuranceCompanyField.FLIGHTS]: Record<CertificatesForInsuranceCompanyField, string>[];
  [CertificatesForInsuranceCompanyField.WORLD_TRACER_NUMBER]: string;
}>;

interface CertificatesForInsuranceCompanyRequiredFieldControls {
  [CertificatesForInsuranceCompanyField.BOOKING_REFERENCE]: string;
  [CertificatesForInsuranceCompanyField.EMAIL]: string;
  [CertificatesForInsuranceCompanyField.FIRST_NAME]: string;
  [CertificatesForInsuranceCompanyField.LAST_NAME]: string;
  [CertificatesForInsuranceCompanyField.PHONE]: string;
  [CertificatesForInsuranceCompanyField.REASON_FOR_CERTIFICATE]: CertificatesForInsuranceCompanyReason;
  [CertificatesForInsuranceCompanyField.TICKET_NUMBER]: string;
}

export type CertificatesForInsuranceCompanyFormData = CertificatesForInsuranceCompanyConditionalFieldControls &
  CertificatesForInsuranceCompanyRequiredFieldControls;

export interface CertificatesForInsuranceCompanyPayload extends CertificatesForInsuranceCompanyFormData {
  locale: string;
}

export enum CertificatesForInsuranceCompanyReason {
  BAGGAGE_DELAYED_OR_DAMAGED = 'baggageDelayedOrDamaged',
  FLIGHT_DELAYED_OR_CANCELLED = 'flightDelayedOrCancelled',
  NO_SHOW = 'noShow',
  ONBOARD = 'onBoard',
  SELF_CANCELLED_BOOKING = 'selfCancelledBooking',
}
